// auth.service.ts
import { Injectable } from '@angular/core';
import {ApiService} from "./api.service";

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private userPermissions: string[] = [];

  constructor(private apiService: ApiService) {

  }

  // checking if the user is authenticated
  isAuthenticated(): boolean {
    let oUserData = localStorage.getItem('app');
    return !!oUserData;
  }

  setPermissions(permissions: string[]): void {
    this.userPermissions = permissions;
  }

  hasPermission(requiredPermission: string): boolean {
    let uData = this.apiService.getUserData()
    let permissions = uData.PERMISSIONS;
    return permissions.includes(requiredPermission);
  }
}
